define('views/annotations/list',[
  "globals",
  "../abstract-comments/list",
  "./annotation"
], function (globals, AbstractCommentListView, AnnotationView) {
  "use strict";

  return AbstractCommentListView.extend({
    initialize: function () {
      this.listenTo(globals.content, "change:location", this.destroy);
      this.listenTo(this.collection, "create:comment", this.renderAnnotation);
    },

    render: function () {
      if (this.collection.isEmpty()) {
        this.$el.html($("<p/>", {
          "class": "no-comments",
          text: Messages("annotation.list.no_annotations")
        }));
      } else {
        this.$el.empty();

        this.collection.each(function (model) {
          this.renderAnnotation(model);
        }, this);
      }

      return this;
    },

    renderAnnotation: function (model) {
      this.$(".no-comments").remove();

      this.$el.append(new AnnotationView({
        collection: this.collection,
        model: model,
        id: model.id
      }).render().el);
    }
  });
});

